export default function AirFryer(props: any) {
    return (
        <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M7.85315 6.68044C7.85315 6.68044 5.62789 15.9473 5.07222 21.3984C4.51654 26.8495 7.29748 28.4849 8.96449 28.4849H19.5223C21.1893 28.4849 26.1903 29.03 26.746 23.5789C27.1905 19.218 24.9653 9.9511 24.5233 7.77066C24.0813 5.59022 23.4116 4.5 21.7449 4.5H10.6315C8.85336 4.5 8.03837 5.95363 7.85315 6.68044Z"
                stroke="#757575"
                strokeWidth="1.09022"
            />
            <path d="M18.082 17.0371H26.2587" stroke="#757575" strokeWidth="1.09022" />
            <path d="M6.08984 17.0371H13.7214" stroke="#757575" strokeWidth="1.09022" />
            <rect x="13.7227" y="15.4023" width="4.36088" height="10.9022" rx="2.18044" stroke="#757575" strokeWidth="1.09022" />
            <ellipse cx="15.9027" cy="7.77088" rx="1.09022" ry="1.09022" stroke="#757575" strokeWidth="1.09022" />
            <ellipse cx="15.9027" cy="12.1312" rx="1.09022" ry="1.09022" stroke="#757575" strokeWidth="1.09022" />
        </svg>
    );
}
